import {
  alpha,
  Box,
  Button,
  styled,
  ToolbarGroup,
  Typography,
} from '@sb/cc-design-system';

export const TOGGLE_HEIGHT = 38;
export const TOOLBAR_HEIGHT = 52;

export const MenuBoardModificationPageWrapper = styled(Box)`
  width: 100%;
  height: 100vh;
  box-sizing: border-box;
  padding: 32px 16px;
`;

export const GCFPreviewWrapper = styled(Box)`
  height: calc(100% - ${TOGGLE_HEIGHT}px - ${TOOLBAR_HEIGHT}px);
  width: 100%;
`;

export const GCFPreviewBox = styled(Box)`
  flex: 1;
  width: 100%;
  display: flex;
  flex-direction: column;
  min-height: 0;
`;

export const IconWrapper = styled(Box)(
  ({ theme }) => `
  display: flex;
  gap: 16px;
  padding: 2px;
  > svg {
    font-size: 20px;
    color: ${theme.colorPalette.neutral.text.primary};
  }
`,
);

export const StyledToolbarGroup = styled(ToolbarGroup)`
  margin: 50px auto 0;
  flex-shrink: 0;
`;

export const ContentHeader = styled(Box)`
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  width: 100%;
`;

export const SectionClickInfo = styled(Typography)(
  ({ theme }) => `
  color: ${alpha(theme.colorPalette.neutral.text.primary, 0.38)};
  grid-column: 3;
  justify-self: end;
`,
);

export const ValidationChipList = styled(Box)`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
  min-height: 24px;
`;

export const ValidationHeaderInfo = styled(Box)(
  ({ theme }) => `
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  color: ${alpha(theme.colorPalette.neutral.text.primary, 0.6)};

  > svg {
    font-size: 15px;
    color: ${alpha(theme.colorPalette.neutral.text.primary, 0.6)};
  }
`,
);

export const ViewAllButton = styled(Button)`
  grid-column: 2;
  justify-self: center;

  .MuiButton-endIcon svg {
    color: #0000008f;
    width: 16px;
    height: 20px;
  }
`;

export const ButtonsWrapper = styled(Box)`
  display: flex;
  gap: 8px;
`;
